import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import MaskedInput from 'react-text-mask';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
const MaskedInputSSN = /*#__PURE__*/React.forwardRef((props, inputRef) => /*#__PURE__*/_jsx(MaskedInput, _extends({
  ref: ref => inputRef && inputRef(ref ? ref.inputElement : null)
}, props, {
  mask: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  placeholder: "000-00-0000",
  inputMode: "numeric"
})));
export default MaskedInputSSN;